export default __webpack_public_path__ + "static/media/user.1bf1ffb7.svg";